export const TrailerType = {
  ALL: 'None',
  REEFER: 'Reefer',
  VAN: 'Van',
  CONTAINER_REEFER: 'ContainerReefer',
  CONTAINER_DRY: 'ContainerDry',
  LIVESTOCK: 'Livestock',
  OPEN_TOP: 'OpenTop',
  TANKER: 'Tanker',
  SIDE_DUMP: 'SideDump',
  FLATBED: 'Flatbed',
  CURTAINSIDE: 'Curtainside',
  HOPPER: 'Hopper',
} as const;

export type TrailerType = (typeof TrailerType)[keyof typeof TrailerType];
